import styled from "styled-components"

export const InfoContainer = styled.div`
    color: #fff;
    background: var(--color_background);

    @media screen and (max-width: 768px) {
        padding: 100px 0;
    }

    @media screen and (max-width: 350px) {
        padding: 25px 0;
    }
`

export const InfoWrapper = styled.div`
    display: grid;
    z-index: 1;
    height: ${({big}) => big ? "760px" : "560px"};
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    justify-content: center;

    @media screen and (max-width: 576px) {
        height: auto;
    }
`

export const InfoRow = styled.div`
    display: grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items: center;
    grid-template-areas: ${({ imgStart }) => (imgStart === "true" ? `'col2 col1'` : `'col1 col2'`)};
    grid-gap: 100px;

    @media screen and (max-width: 768px) {
        grid-template-areas: ${({ imgStart }) => (imgStart === "true" ? `'col2' 'col1'` : `'col2 col2' 'col1 col1'`)};
        grid-gap: 0;
    }
`

export const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col1;
`

export const Column2 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col2;
    margin: auto;
`

export const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;

    @media screen and (max-width: 576px) {
        padding-bottom: 30px;
    }
`

export const TopLine = styled.p`
    color: var(--brand_color_primary);
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom:  16px;
`

export const Heading = styled.h1`
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 1.1;
    font-weight: 600;
    color: #010606;

    @media screen and (max-width: 480px) {
        font-size: 32px;
    }
`

export const Subtitle = styled.p`
    max-width: 440px;
    margin-bottom: 18px;
    font-size: 18px;
    line-height: 24px;
    color: #010606;

    @media screen and (max-width: 480px) {
        font-size: 16px;
    }
`

export const BtnWrap = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;
`

export const ImgWrap = styled.div`
    max-width: 555px;
    height: 100%;
    margin: 30px;

    @media screen and (max-width: 768px) {
        max-width: 350px;
    }
`

export const Img = styled.img`
    width: 100%;
    margin: 0 0 10px 0;
    padding-right: 0;
`

export const Divider = styled.hr`
    margin: 0;
    width: 70%;
    margin-left: 15%;
    position: absolute;
`